import React, { useState } from 'react';

const teamMembers = [
  {
    id: 1,
    name: "Sayali Shelke",
    designation: "Software Developer",
    category: "Engineering & Technology",
    initials: "SS",
    bio: "Specializes in building robust full-stack web applications, scalable client solutions, and modern software architectures.",
    featured: true
  },
  {
    id: 2,
    name: "Aarav Sharma",
    designation: "Creative Director",
    category: "Creative & Design",
    initials: "AS",
    bio: "Leads creative strategy, visual storytelling, and brand identity systems across multi-platform agency campaigns."
  },
  {
    id: 3,
    name: "Priya Patel",
    designation: "Lead UI/UX Designer",
    category: "Creative & Design",
    initials: "PP",
    bio: "Crafts intuitive, user-centered digital interfaces and visual experiences for web & mobile applications."
  },
  {
    id: 4,
    name: "Rohan Verma",
    designation: "Senior Full Stack Developer",
    category: "Engineering & Technology",
    initials: "RV",
    bio: "Expert in frontend React frameworks, API integration, performance optimization, and database architecture."
  },
  {
    id: 5,
    name: "Ananya Iyer",
    designation: "Head of Digital Marketing",
    category: "Digital Strategy & Marketing",
    initials: "AI",
    bio: "Drives multi-channel marketing campaigns, brand positioning, and ROI-driven digital growth strategies."
  },
  {
    id: 6,
    name: "Vikramaditya Deshmukh",
    designation: "SEO Strategy Lead",
    category: "Digital Strategy & Marketing",
    initials: "VD",
    bio: "Specializes in organic search growth, technical SEO audits, keyword strategy, and content optimization at scale."
  },
  {
    id: 7,
    name: "Kavya Kulkarni",
    designation: "Social Media Manager",
    category: "Digital Strategy & Marketing",
    initials: "KK",
    bio: "Creates engaging social content, audience growth campaigns, and brand storytelling across digital channels."
  },
  {
    id: 8,
    name: "Aditya Joshi",
    designation: "Brand Strategist",
    category: "Digital Strategy & Marketing",
    initials: "AJ",
    bio: "Helps businesses articulate their core brand identity, strategic positioning, and digital market presence."
  },
  {
    id: 9,
    name: "Neha Agarwal",
    designation: "Frontend Engineer",
    category: "Engineering & Technology",
    initials: "NA",
    bio: "Focuses on responsive user interfaces, CSS micro-animations, interactive components, and web performance."
  },
  {
    id: 10,
    name: "Rahul Nair",
    designation: "Motion & Graphic Designer",
    category: "Creative & Design",
    initials: "RN",
    bio: "Produces high-impact visual graphics, motion visualizers, and brand media assets for digital campaigns."
  },
  {
    id: 11,
    name: "Pooja Hegde",
    designation: "Content Operations Lead",
    category: "Management & Operations",
    initials: "PH",
    bio: "Oversees editorial workflows, brand messaging consistency, and creative copywriting strategy."
  },
  {
    id: 12,
    name: "Siddharth Mehta",
    designation: "AI Solutions Engineer",
    category: "Engineering & Technology",
    initials: "SM",
    bio: "Builds intelligent AI workflows, automated media production pipelines, and generative tech integrations."
  },
  {
    id: 13,
    name: "Rutuja Patil",
    designation: "Performance Marketing Specialist",
    category: "Digital Strategy & Marketing",
    initials: "RP",
    bio: "Manages paid acquisition, ad conversions, and data-driven marketing funnels across search and social."
  },
  {
    id: 14,
    name: "Devendra Kadam",
    designation: "Backend Architect",
    category: "Engineering & Technology",
    initials: "DK",
    bio: "Engineers secure backend APIs, microservices architecture, server infrastructure, and database integrations."
  },
  {
    id: 15,
    name: "Sneha Redkar",
    designation: "Client Relationship Manager",
    category: "Management & Operations",
    initials: "SR",
    bio: "Ensures seamless communication between clients and internal creative teams to achieve key project milestones."
  },
  {
    id: 16,
    name: "Karan Kapoor",
    designation: "Copywriter & Storyteller",
    category: "Creative & Design",
    initials: "KK",
    bio: "Crafts compelling web copy, ad messaging, brand narratives, and creative concepts that engage audiences."
  }
];

const categories = [
  "All",
  "Engineering & Technology",
  "Creative & Design",
  "Digital Strategy & Marketing",
  "Management & Operations"
];

function TeamList() {
  const [activeCategory, setActiveCategory] = useState("All");

  const filteredMembers = activeCategory === "All"
    ? teamMembers
    : teamMembers.filter(m => m.category === activeCategory);

  return (
    <section className="team-section section-padding position-re">
      <div className="container">
        {/* Category Filter Pills */}
        <div className="row justify-content-center mb-60">
          <div className="col-lg-12">
            <div className="filtering text-center">
              <div className="filter-pills d-flex flex-wrap justify-content-center gap-2">
                {categories.map((cat, idx) => (
                  <button
                    key={idx}
                    className={`btn-filter ${activeCategory === cat ? 'active' : ''}`}
                    onClick={() => setActiveCategory(cat)}
                    style={{
                      padding: '10px 22px',
                      borderRadius: '30px',
                      border: activeCategory === cat ? '1px solid #ff5e3a' : '1px solid rgba(0, 0, 0, 0.1)',
                      backgroundColor: activeCategory === cat ? '#ff5e3a' : 'transparent',
                      color: activeCategory === cat ? '#fff' : '#222',
                      fontSize: '14px',
                      fontWeight: '500',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease',
                      margin: '4px'
                    }}
                  >
                    {cat}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Team Grid */}
        <div className="row">
          {filteredMembers.map((member) => (
            <div key={member.id} className="col-lg-4 col-md-6 mb-40">
              <div
                className="team-card h-100 p-4 rounded-4"
                style={{
                  border: '1px solid rgba(0, 0, 0, 0.08)',
                  borderRadius: '16px',
                  backgroundColor: '#ffffff',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.03)',
                  transition: 'all 0.3s ease',
                  display: 'flex',
                  flexDirection: 'column',
                  justify: 'space-between',
                  position: 'relative',
                  overflow: 'hidden'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-6px)';
                  e.currentTarget.style.boxShadow = '0 12px 30px rgba(0,0,0,0.08)';
                  e.currentTarget.style.borderColor = '#ff5e3a';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.03)';
                  e.currentTarget.style.borderColor = 'rgba(0, 0, 0, 0.08)';
                }}
              >
                {/* Header: Initials Badge & Category Tag */}
                <div>
                  <div className="d-flex align-items-center justify-content-between mb-25">
                    <div
                      className="initials-avatar d-flex align-items-center justify-content-center"
                      style={{
                        width: '56px',
                        height: '56px',
                        borderRadius: '50%',
                        background: 'linear-gradient(135deg, #181818 0%, #333333 100%)',
                        color: '#ffffff',
                        fontWeight: '700',
                        fontSize: '18px',
                        letterSpacing: '1px',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                      }}
                    >
                      {member.initials}
                    </div>
                    <span
                      className="category-badge"
                      style={{
                        fontSize: '12px',
                        fontWeight: '600',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                        padding: '4px 12px',
                        borderRadius: '20px',
                        backgroundColor: 'rgba(255, 94, 58, 0.08)',
                        color: '#ff5e3a'
                      }}
                    >
                      {member.category.split(' & ')[0]}
                    </span>
                  </div>

                  {/* Name and Designation */}
                  <h4 className="fw-700 fz-22 mb-5" style={{ color: '#111' }}>
                    {member.name}
                  </h4>
                  <h6
                    className="sub-title main-color fw-600 mb-15"
                    style={{ fontSize: '14px', textTransform: 'uppercase', letterSpacing: '1px' }}
                  >
                    {member.designation}
                  </h6>

                  {/* Short Role Summary */}
                  <p className="fz-14 opacity-7 mb-20" style={{ lineHeight: '1.6' }}>
                    {member.bio}
                  </p>
                </div>

                {/* Footer element */}
                <div
                  className="pt-15 bord-thin-top d-flex align-items-center justify-content-between"
                  style={{ borderTop: '1px solid rgba(0, 0, 0, 0.06)' }}
                >
                  <span className="fz-12 opacity-6 text-u">Aashway Agency</span>
                  <span className="icon ti-check-box main-color fz-14"></span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TeamList;
